import React from 'react';
import { Link } from 'react-router-dom';

// Gör länkar i vanlig text klickbara.
// Stöder två format i beskrivningen:
//   1. [Visa katalog](https://exempel.se/katalog.pdf)  -> länk med egen text
//   2. https://exempel.se/katalog.pdf                  -> adressen blir länk direkt
// Länkar som börjar med "/" (t.ex. [Se alla drycker](/products/3)) öppnas inom sidan.

const LINK_PATTERN = /\[([^\]]+)\]\(((?:https?:\/\/|\/)[^\s)]+)\)|(https?:\/\/[^\s<]+[^\s<.,;:!?)])/g;

const renderLink = (href: string, text: string, key: number) =>
  href.startsWith('/') ? (
    <Link key={key} to={href}>{text}</Link>
  ) : (
    <a key={key} href={href} target="_blank" rel="noopener noreferrer">{text}</a>
  );

const LinkifiedText: React.FC<{ text?: string | null }> = ({ text }) => {
  if (!text) return null;

  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let key = 0;

  for (const match of Array.from(text.matchAll(LINK_PATTERN))) {
    const index = match.index ?? 0;
    if (index > lastIndex) parts.push(text.slice(lastIndex, index));

    const [, label, labelHref, bareUrl] = match;
    parts.push(label ? renderLink(labelHref, label, key++) : renderLink(bareUrl, bareUrl, key++));

    lastIndex = index + match[0].length;
  }

  if (lastIndex < text.length) parts.push(text.slice(lastIndex));

  return <>{parts}</>;
};

export default LinkifiedText;